export class ImageSearchResult {
    ImageId: string;
    Name: string;
    MimeType: string;
    Size: number;
    ClientId: string;
    CreateUserId: string;
    CreateDate: Date;
}
